module.exports = __webpack_public_path__ + "img/kbstar_visual_m.87ba055b.jpg";